module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('a', {
    attrs: {
      "href": "#/9780061748714_chapter_01#ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he Girl Who Raised Pigeons")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he First Day")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he Night Rhonda Ferguson Was Killed")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Y"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oung Lions")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he Store")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n Orange Line Train to Ballston")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he Sunday Following Mother’s Day")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("L"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ost in the City")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is Mother’s House")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Butterfly on F Street")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("G"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ospel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New Man")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dark Night")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arie")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bmp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_backmatterpage#bmp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Selection from")])]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("All Aunt Hagar’s Children:")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Rich Man")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('p', {
    staticClass: "contentsEntryText"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9780061748714_aboutauthor#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "rev_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_review#rev01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praise")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "acp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('a', {
    attrs: {
      "id": "ztocz"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9780061748714_adcard#zhead1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by Edward P. Jones")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ill_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_backmatterpage_02#ill01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Credits")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryText"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061748714_aboutpublisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Publisher")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11158f3b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061748714_contents.vue
// module id = 66
// module chunks = 0